import { BackofficeMenu } from "../types/backoffice";
import { UserRole } from "../types";

const BACKOFFICE_MENU_PATHS: Record<BackofficeMenu, string> = {
    [BackofficeMenu.Dashboard]: '/backoffice',
    [BackofficeMenu.Users]: '/backoffice-users',
    [BackofficeMenu.Messages]: '/backoffice-messages',
    [BackofficeMenu.AiHub]: '/backoffice-ai-hub',
    [BackofficeMenu.BusinessHours]: '/backoffice-business-hours',
    [BackofficeMenu.Reports]: '/backoffice-reports',
    [BackofficeMenu.Scheduler]: '/backoffice-scheduler',
    [BackofficeMenu.QueueMonitor]: '/backoffice-queue-monitor'
};

export class UserHelper {
    public static getAllowedRoles(role?: UserRole | null): UserRole[] {
        if (!role) {
            return [];
        }

        switch (role) {
            case UserRole.Admin:
                return [UserRole.Client, UserRole.Agent, UserRole.Panel, UserRole.Admin];
            case UserRole.Panel:
                return [UserRole.Agent, UserRole.Panel];
            case UserRole.Agent:
                return [UserRole.Agent];
            default:
                return [];
        }
    }

    public static canManageRole(currentUserRole?: UserRole | null | undefined, targetUserRole?: UserRole | null | undefined): boolean {
        if (!currentUserRole || !targetUserRole) {
            return false;
        }

        return this.getAllowedRoles(currentUserRole).includes(targetUserRole);
    }

    public static isChatUserRole(role?: UserRole | null | undefined): boolean {
        return role ? this.chatAgentUsers().concat([UserRole.Client]).includes(role) : false;
    }

    public static isAgentUserRole(role?: UserRole | null | undefined): boolean {
        return role ? this.chatAgentUsers().includes(role) : false;
    }

    public static chatAgentUsers(): UserRole[] {
        return [UserRole.Agent, UserRole.Panel, UserRole.Admin];
    }

    public static getAccessibleBackofficeMenus(role?: UserRole | null): BackofficeMenu[] {
        if (!role) {
            return [];
        }

        switch (role) {
            case UserRole.Admin:
                return [
                    BackofficeMenu.Dashboard,
                    BackofficeMenu.Users,
                    BackofficeMenu.Messages,
                    BackofficeMenu.AiHub,
                    BackofficeMenu.BusinessHours,
                    BackofficeMenu.Reports,
                    BackofficeMenu.Scheduler,
                    BackofficeMenu.QueueMonitor
                ];
            case UserRole.Panel:
                return [
                    BackofficeMenu.Dashboard,
                    BackofficeMenu.Reports,
                    BackofficeMenu.Messages,
                    BackofficeMenu.Scheduler
                ];
            case UserRole.Agent:
                return [BackofficeMenu.Dashboard];
            default:
                return [];
        }
    }

    public static canAccessBackofficePath(role?: UserRole | null, path?: string): boolean {
        if (!role || !path) {
            return false;
        }

        return this.getAccessibleBackofficeMenus(role).some(
            menu => BACKOFFICE_MENU_PATHS[menu] === path
        );
    }

    public static getBackofficeMenuPath(menu: BackofficeMenu): string {
        return BACKOFFICE_MENU_PATHS[menu];
    }

    public static getHomePath(role?: UserRole | null): string {
        if (!role) {
            return '/login';
        }

        if (role === UserRole.Client) {
            return '/client';
        }

        const accessibleMenus = this.getAccessibleBackofficeMenus(role);
        if (accessibleMenus.length > 0) {
            return BACKOFFICE_MENU_PATHS[accessibleMenus[0]];
        }

        return '/login';
    }
}
